import { menu } from './menu';
import { resources as feeResources, feeTemplates, feeSchedules, userGroups, reservationPolicies, reservations } from './resources/index';
import { feeTemplateChanges } from './resources/fee-template-changes';
import { auditLogsResource, auditLogs } from './resources/audit-logs';
import { rolesResource, roles } from './resources/roles';
import { backendUsersResource, backendUsers } from './resources/backend-users';
import { chargerTypesResource, chargerTypes } from './resources/charger-types';
import { chargersResource, chargers } from './resources/chargers';
import { ocppTemplatesResource, ocppTemplates } from './resources/ocpp-templates';
import { lmsTemplatesResource, lmsTemplates } from './resources/lms-templates';
import { loadGroupsResource, loadGroups } from './resources/load-groups';
import { sitesResource, sites } from './resources/sites';
import { settings } from './resources/settings';
import { notificationGroups } from './resources/notification-groups';
import { notificationLogs } from './resources/notification-logs';
import { lmsLogsResource, lmsLogs } from './resources/lms-logs';
import ocppServers from './resources/ocpp-servers';
import { chargerFirmwareResource, chargerFirmware } from './resources/charger-firmware';
import { firmwareUpdatesResource, firmwareUpdates } from './resources/firmware-updates';
import { appTransactions } from './resources/app-transactions';
import { rfidTransactions } from './resources/rfid-transactions';

// Import other modular translations
import { common, accessDenied, validation } from './common';
import { status } from './status';
import { dashboard } from './dashboard';
import { users } from './users';
import { errors } from './errors';
import { auth } from './auth';
import { language } from './language';
import { notifications } from './notifications';
import { preferences } from './preferences';
import { reactAdmin } from './react-admin';
import { app } from './app';
import { cronMonitor } from './cron-monitor';
import { ocppLogs } from './ocpp-logs';
import { reports } from './reports';
import { emailRouting } from './email-routing';
import { aiTroubleshooting } from './ai-troubleshooting';

export const zhTW = {
  ...reactAdmin, // Add React Admin translations
  app, // Add the app translations
  resources: {
    ...feeResources, // Merge fee-related resources
    // Merge the extended translations for fee-templates
    'fee-templates': {
      ...feeResources['fee-templates'],
      ...feeTemplates,
    },
    // Merge the extended translations for fee-schedules
    'fee-schedules': {
      ...feeResources['fee-schedules'],
      ...feeSchedules,
    },
    // Merge the extended translations for fee-template-changes
    'fee-template-changes': {
      ...feeResources['fee-template-changes'],
      ...feeTemplateChanges,
    },
    // Merge the extended translations for audit-logs
    'audit-logs': {
      ...auditLogsResource,
      ...auditLogs,
    },
    // Merge the extended translations for roles
    roles: {
      ...rolesResource,
      ...roles,
    },
    // Merge the extended translations for backend-users
    'backend-users': {
      ...backendUsersResource,
      ...backendUsers,
    },
    // Merge the extended translations for charger-types
    'charger-types': {
      ...chargerTypesResource,
      ...chargerTypes,
    },
    // Merge the extended translations for chargers
    chargers: {
      ...chargersResource,
      ...chargers,
    },
    // Merge the extended translations for ocpp-templates
    'ocpp-templates': {
      ...ocppTemplatesResource,
      ...ocppTemplates,
    },
    // Merge the extended translations for lms-templates
    'lms-templates': {
      ...lmsTemplatesResource,
      ...lmsTemplates,
    },
    // Merge the extended translations for load-groups
    'load-groups': {
      ...loadGroupsResource,
      ...loadGroups,
    },
    // Merge the extended translations for sites
    sites: {
      ...sitesResource,
      ...sites,
    },
    // Add notification groups translations
    'notification-groups': notificationGroups,
    'notification-logs': notificationLogs,
    // Merge the extended translations for lms-logs
    'lms-logs': {
      ...lmsLogsResource,
      ...lmsLogs,
    },
    // Add OCPP servers translations
    'ocpp-servers': ocppServers,
    // Merge the extended translations for charger-firmware
    'charger-firmware': {
      ...chargerFirmwareResource,
      ...chargerFirmware,
    },
    // Merge the extended translations for firmware-updates
    'firmware-updates': {
      ...firmwareUpdatesResource,
      ...firmwareUpdates,
    },
    // Add app-transactions translations
    'app-transactions': appTransactions,
    // Add rfid-transactions translations
    'rfid-transactions': rfidTransactions,
    // Merge user-groups translations
    'user-groups': {
      ...feeResources['user-groups'],
      ...userGroups,
    },
    // Merge reservation-policies translations
    'reservation-policies': {
      ...feeResources['reservation-policies'],
      ...reservationPolicies,
    },
    // Merge reservations translations
    reservations: {
      ...feeResources['reservations'],
      ...reservations,
    },
  },
  settings, // Add the settings translations
  common, // Add the common translations
  status, // Add the status translations
  dashboard, // Add the dashboard translations
  users, // Add the users translations
  errors, // Add the errors translations
  menu, // Add the new modular menu translations
  auth, // Add the modular auth translations
  language, // Add the modular language translations
  notifications, // Add the modular notifications translations
  preferences, // Add the modular preferences translations
  cronMonitor, // Add the cron monitor translations
  ocppLogs, // Add the OCPP logs translations
  reports, // Add the reports translations
  emailRouting, // Email provider routing page translations
  aiTroubleshooting, // AI troubleshooting page translations
  accessDenied,
  validation,
};